export default __webpack_public_path__ + "static/media/364.1640cc8d.gif";